import { ReactNode, useEffect } from 'react';
import MediaQuery from 'react-responsive';
import { Header, HeaderMobile } from './widgets';
import { SessionStorageUtils } from '@shared/utils';
import { useGetAccountsStore, useGetContactsStore, useGetDictionariesStore, useGetStatusStore } from '@lib/store';

interface PageLayoutType {
  children: ReactNode;
}

const menu = [
  {
    link: '/dashboard',
    name: 'Home',
  },
  {
    link: '/dashboard/accounts/:id',
    name: 'Accounts',
  },
  {
    link: '/dashboard/cards',
    name: 'Cards',
  },
  {
    link: '/dashboard/payments',
    name: 'Payments',
  },
  {
    link: '/dashboard/contact-us',
    name: 'Contact us',
  },
];

export const PageLayout = (props: PageLayoutType) => {
  const contactsStore = useGetContactsStore();
  const dictionariesStore = useGetDictionariesStore();
  const accountsStore = useGetAccountsStore();
  const statusStore = useGetStatusStore();

  useEffect(() => {
    dictionariesStore.get();
    contactsStore.get();
    accountsStore.get();
    statusStore.get();
  }, []);

  SessionStorageUtils.setToken(SessionStorageUtils.getToken());

  return (
    <div className='relative pb-12'>
      <MediaQuery query='(max-width: 768px)'>
        <HeaderMobile menu={menu} />
      </MediaQuery>
      <MediaQuery query='(min-width: 769px)'>
        <Header menu={menu} />
      </MediaQuery>
      <div className='min-h-[calc(100vh-80px)] overflow-hidden pt-20 max-md:pt-16'>{props.children}</div>
    </div>
  );
};
